/**
 * @constant {number}
 * @memberof Constants
 */
export const GREENHOUSE = 1;

/**
 * @constant {number}
 * @memberof Constants
 */
export const LEVER = 2;

/**
 * @constant {number}
 * @memberof Constants
 */
export const WORKDAY = 4;

/**
 * @constant {number}
 * @memberof Constants
 */
export const SUCCESSFACTORS = 7;

/**
 * @constant {number}
 * @memberof Constants
 */
export const SMARTRECRUITERS = 12;

/**
 * @constant {number}
 * @memberof Constants
 */
export const CORNERSTONE = 16;

/**
 * @constant {number}
 * @memberof Constants
 */
export const GR8PEOPLE = 22;

/**
 * @constant {number}
 * @memberof Constants
 */
export const ICIMS = 24;

/**
 * @constant {number}
 * @memberof Constants
 */
export const PEOPLEFLUENT = 18;
